var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{ref:"formContainer"},[_c('form-component',{attrs:{"page":_vm.forDesigners},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchForDesigners}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }